module.exports = __webpack_public_path__ + "img/img10.54fe70c7.svg";